export default __webpack_public_path__ + "static/media/img-contacto.f0ba0daa.png";